import { ParagraphSmall } from "baseui/typography";
import { HorizontalStackPanel } from "../../components/Layout/StackPanel";
import { IoPinSharp } from "react-icons/io5";
import { useStyletron } from "baseui";
import { IAddress } from "@oqdo/automationapps/Spaces/Address";

const TenantAddress: React.FC<{ address: IAddress | undefined }> = (props) => {
  const { address } = props;
  const [css, theme] = useStyletron();

  if (!address?.addressLine1) return <></>;
  return (
    <HorizontalStackPanel>
      <IoPinSharp color={theme.colors.accent} />
      <ParagraphSmall>{address.addressLine1},</ParagraphSmall>
      <ParagraphSmall>
        {address.postalCode} {address.city},
      </ParagraphSmall>
      <ParagraphSmall>{address.country}</ParagraphSmall>
    </HorizontalStackPanel>
  );
};

export default TenantAddress;
